import React from 'react';
import { useTheme } from '@/context/ThemeContext';
import Icon from '@/components/Icon';
import PropTypes from 'prop-types';

const DropdownIcon = React.memo(({
    isActive = false,
    inactiveIcon = undefined,
}) => {
  const { colors } = useTheme();
  
  return (
    <Icon 
      size={14} 
      name={isActive ? "circle-check" : !!inactiveIcon ? inactiveIcon : "circle"}
      solid={isActive} 
      color={isActive ? colors.accent_text_color : colors.text_color_tertiary}
      accessibilityLabel={isActive ? "Selected" : "Not selected"}
      accessibilityRole="image"
    />
  );
});

DropdownIcon.propTypes = {
  isActive: PropTypes.bool,
};

DropdownIcon.displayName = 'DropdownIcon';

export default DropdownIcon; 